import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import Switch from '../Switch';
import Action from '../Action';
import Popover from '../Popover';

/**
 * `SwitchesPanelItem` component is used for combining [Switch](#!/Switch) component with text title and description.
 * Used in [SwitchesPanel](#!/SwitchesPanel).
 * @since 0.3.0
 */
var SwitchesPanelItem =
/*#__PURE__*/
function (_Component) {
  _inherits(SwitchesPanelItem, _Component);

  function SwitchesPanelItem() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SwitchesPanelItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SwitchesPanelItem)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      checked: _this.props.defaultChecked
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (checked) {
      _this.setState({
        checked: checked
      });

      _this.props.onChange(checked);
    });

    return _this;
  }

  _createClass(SwitchesPanelItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onChange = _this$props.onChange,
          defaultChecked = _this$props.defaultChecked,
          intent = _this$props.intent,
          title = _this$props.title,
          description = _this$props.description,
          fullDescription = _this$props.fullDescription,
          baseClassName = _this$props.baseClassName,
          className = _this$props.className,
          switchProps = _this$props.switchProps,
          children = _this$props.children,
          props = _objectWithoutProperties(_this$props, ["onChange", "defaultChecked", "intent", "title", "description", "fullDescription", "baseClassName", "className", "switchProps", "children"]);

      var checked = this.state.checked;
      return React.createElement("div", _extends({
        className: classNames(baseClassName, _defineProperty({}, "".concat(baseClassName, "--").concat(intent), intent && checked), className)
      }, props), React.createElement("h5", {
        className: "".concat(baseClassName, "__title")
      }, title), description && React.createElement("p", {
        className: "".concat(baseClassName, "__description")
      }, description), React.createElement("div", {
        className: "".concat(baseClassName, "__actions")
      }, React.createElement(Switch, _extends({
        className: "".concat(baseClassName, "__switch"),
        intent: intent,
        onChange: this.handleChange,
        defaultChecked: defaultChecked
      }, switchProps)), (fullDescription || children) && React.createElement("div", {
        className: "".concat(baseClassName, "__controls")
      }, children, fullDescription && React.createElement(Popover, {
        intent: "info",
        target: React.createElement(Action, {
          icon: "question-mark-circle",
          outerProps: {
            className: "".concat(baseClassName, "__full-description-toggle")
          }
        }),
        placement: "bottom"
      }, fullDescription))));
    }
  }]);

  return SwitchesPanelItem;
}(Component);

SwitchesPanelItem.propTypes = {
  /**
   * A callback function, can be executed when the checked state is changing.
   * @since 0.3.0
   */
  onChange: PropTypes.func.isRequired,

  /**
   * @ignore
   */
  defaultChecked: PropTypes.bool,

  /**
   * Visual intent color to apply to component.
   * @since 0.3.0
   */
  intent: PropTypes.oneOf(['warning', 'danger']),

  /**
   * Title of the `SwitchesPanelItem`. Must be no longer than two lines.
   * @since 0.3.0
   */
  title: PropTypes.node.isRequired,

  /**
   * `SwitchesPanelItem` description. Must be no longer than three lines.
   * @since 0.3.0
   */
  description: PropTypes.node,

  /**
   * Rich full description of the `SwitchesPanelItem`.
   * Adds control button with question mark that shows `Popover` on click.
   * @since 0.3.0
   */
  fullDescription: PropTypes.node,

  /**
   * Props of underlying [Switch](#!/Switch) component.
   * @since 0.5.0
   */
  switchProps: PropTypes.object,

  /**
   * Content of the control actions.
   * Don't place here more than three buttons (with the one from 'fullDescription' property) or one link and one button.
   * @since 0.3.0
   */
  children: PropTypes.node,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  baseClassName: PropTypes.string
};
SwitchesPanelItem.defaultProps = {
  defaultChecked: false,
  intent: null,
  description: null,
  fullDescription: null,
  switchProps: {},
  children: null,
  className: null,
  baseClassName: "".concat(CLS_PREFIX, "switches-panel-item")
};
export default SwitchesPanelItem;